export default __webpack_public_path__ + "static/media/fail.5ca4379d.png";